<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
        <div class="content container-fluid">
            <select-report-user-modal @onUsersSelected="getSelectedUsers"></select-report-user-modal>
            <div class="row filter-row mb-5 position-relative">
                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 col-12 employee-name" style="margin-right: auto">
                    <h4>Employee Report</h4>
                </div>
                <div class="floating-search-container" :class="{ 'expanded': searchFocused || searchQuery !== '' }" v-if="report.length">
                    <div class="search-wrapper">
                        <input v-show="searchFocused || searchQuery !== ''" type="text" ref="searchInput" v-model="searchQuery"
                            @focus="searchFocused = true"
                            @blur="searchFocused = false"
                            class="search-input-field"
                            placeholder="Search by name..." />
                        <div class="search-icon-btn" @click="toggleSearch">
                            <i v-if="!searchQuery" class="fa-solid fa-magnifying-glass text-muted"></i>
                            <i v-else @click.stop="clearSearch" class="fa-solid fa-circle-xmark text-muted"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-md-3 mb-3">
                    <div class="input-block mb-3 form-focus position-relative">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                            style="z-index: 100; font-size: 12px;">Start Date</label>
                        <div class="cal-icon" style="z-index: 90;">
                            <date-picker v-model="startDate" placeholder="Start Date"
                                class="form-control floating datetimepicker" :editable="true" :clearable="false"
                                :inputFormat="dateFormat" @update:model-value="onSearchClick" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 mb-3">
                    <div class="input-block mb-3 form-focus position-relative">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                            style="z-index: 100; font-size: 12px;">End Date</label>
                        <div class="cal-icon" style="z-index: 90;">
                            <date-picker v-model="endDate" placeholder="End Date"
                                class="form-control floating datetimepicker" :editable="true" :clearable="false"
                                :inputFormat="dateFormat" @update:model-value="onSearchClick" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 mb-3">
                    <a href="javascript:;" class="btn btn-secondary w-100" data-bs-toggle="modal"
                        data-bs-target="#select_report_user_modal">
                        Select Employees <span v-if="selectedUsersFromFilter.length">({{ selectedUsersFromFilter.length }})</span>
                    </a>
                </div>
                <div class="col-sm-6 col-md-3 mb-3">
                    <div class="dropdown w-100">
                        <button class="btn btn-success dropdown-toggle w-100 d-inline-flex align-items-center justify-content-center" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="load || dailyReportLoad || membersOnSiteLoad">
                            <span v-if="!load && !dailyReportLoad && !membersOnSiteLoad"><i class="fa-solid fa-download me-2"></i> Download Reports</span>
                            <span class="spinner-border spinner-border-sm" role="status" v-else>
                                <span class="visually-hidden">Loading...</span>
                            </span>
                        </button>
                        <ul class="dropdown-menu w-100">
                            <li>
                                <a class="dropdown-item" :class="{ 'disabled': !selectedUsersFromFilter.length }" href="javascript:;" @click="downloadMultiUserReport">
                                    <span><i class="fa-solid fa-file-invoice me-2 text-success"></i> Summary Report</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="javascript:;" @click="openDateModal('daily')">
                                    <span><i class="fa-solid fa-calendar-day me-2 text-primary"></i> Daily Attendance</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="javascript:;" @click="openDateModal('members')">
                                    <span><i class="fa-solid fa-users-viewfinder me-2 text-warning"></i> Members On Site</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <v-divider opacity="0.5"></v-divider>
            </div>

            <!-- <h4 class="pb-3">Summery</h4> -->
             
            <div v-if="!loading">
                <div v-if="report.length">
                    <div v-if="filteredReport.length">
                        <div v-for="r of filteredReport" :key="r.userId">

                        <v-row>
                            <v-col cols="12" class="pb-0 mt-4">
                                <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    <action-dropdown @banked-time="bankedTimeClicked" 
                                        :employee="{ ...r, id: r.userId, name: r.userName }" 
                                        variant="text" 
                                        :showViewProfile="true"
                                        :reportAsEvent="true"
                                        :truncate="false"
                                        class="h3 mb-0 text-black"
                                        @edit="editClicked" 
                                        @leaves="leavesClicked"
                                        @attendance="attendanceClicked" 
                                        @sick-leave="sickLeaveClicked" 
                                        @face-templates="faceTemplatesClicked" 
                                        @toggle-monitoring="monitorClicked"
                                        @add-face-template="addFaceTemplateClicked"
                                        @report="viewReport"
                                        @assign-employee="assignEmployeeClicked"
                                    />


                                    <div class="d-flex align-items-center">
                                        <div class="btn btn-outline-info" @click="getUserReport($event)">
                                            <i class="fa-solid fa-arrows-rotate me-1" v-if="!isRefreshing"></i>
                                            <span class="spinner-border spinner-border-sm me-1" role="status" v-else></span>
                                            Refresh
                                        </div>
                                        <div class="btn btn-outline-primary ms-3" @click="viewReport({ ...r, id: r.userId })">
                                            View
                                        </div>
                                        <div class="btn btn-outline-success ms-3" @click="downloadUserReport(r)">
                                            <span v-if="!singleDownloadLoad">Download Simple Report</span>
                                            <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                                <div class="spinner-border spinner-border-sm" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn btn-outline-success ms-3" @click="downloadFullReport(r)">
                                            <span v-if="!fullDownloadLoad">Download Full Report</span>
                                            <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                                <div class="spinner-border spinner-border-sm" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Type
                                                </th>
                                                <th class="text-left">
                                                    24H
                                                </th>
                                                <th class="text-left">
                                                    Schedule
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Time on site including break taken</td>
                                                <td>{{ toTimeString(r.timeOnSite) ?? '00:00' }}</td>
                                                <td>{{ toTimeString(r.totalTimeOnSiteIncludingBreakSchedule) ?? '00:00' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Break taken</td>
                                                <td>{{toTimeString(r.totalBreakTime) ?? '00:00' }}</td>
                                                <td>{{toTimeString(r.totalBreakTime) ?? '00:00' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Allowed paid break</td>
                                                <td>{{toTimeString(r.allowedBreak) ?? '00:00' }}<span v-if="r.totalExtraBreak > 0"> (+{{ r.totalExtraBreak }} mins)</span></td>
                                                <td>{{toTimeString(r.allowedBreak) ?? '00:00' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Leave days (Hours worked)</td>
                                                <td>{{ r.paidLeaves ?? 0 }} ({{ toTimeString((r.leaveDayWorkingHours ?? 0) * 60) }})</td>
                                                <td>{{ r.paidLeaves ?? 0 }} ({{ toTimeString((r.leaveDayWorkingHours ?? 0) * 60) }})</td>
                                            </tr>
                                            <tr>
                                                <td>Time on site after break deduction</td>
                                                <td>{{ toTimeString(r.totalTimeOnSiteAfterBreak) ?? '00:00' }}</td>
                                                <td>{{ toTimeString(r.totalTimeOnSiteAfterBreakSchedule) ?? '00:00' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Expected time on site</td>
                                                <td>{{ toTimeString(r.expectedTimeOnSite) ?? '00:00' }}</td>
                                                <td>{{ toTimeString(r.expectedTimeOnSite) ?? '00:00' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Banked time</td>
                                                <td>{{ toTimeString(r.totalBankedTime) ?? '00:00' }}</td>
                                                <td>{{ toTimeString(r.totalBankedTime) ?? '00:00' }}</td>
                                            </tr>
                                            
                                        </tbody>
                                    </template>
                                </v-table>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Type
                                                </th>
                                                <th class="text-left">
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Working days</td>
                                                <td>{{ r.workingDays ?? 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td>Actual days present</td>
                                                <td>{{ r.presentDays ?? 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td>Non working days</td>
                                                <td>{{ r.nonWorkingDays ?? 0 }}</td>
                                            </tr>
                                            <!-- <tr>
                                                <td>Paid leaves</td>
                                                <td>{{ r.paidLeaves ?? 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td>Unpaid leaves</td>
                                                <td>{{ r.unPaidLeaves ?? 0 }}</td>
                                            </tr> -->
                                            <tr>
                                                <td>Absent</td>
                                                <td>{{ r.absent ?? 0 }}</td>
                                            </tr>
                                             <!-- <tr>
                                                 <td>Leave days (Hours worked)</td>
                                                 <td>{{ r.paidLeaves ?? 0 }} ({{ toTimeString((r.leaveDayWorkingHours ?? 0) * 60) }})</td>
                                             </tr> -->
                                            <tr>
                                                <td>Unpaid leaves</td>
                                                <td>{{ r.unPaidLeaves ?? 0 }}</td>
                                            </tr>
                                            <tr>
                                                <td>Sick leave</td>
                                                <td>{{ r.totalSickLeaveDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Unscheduled work days</td>
                                                <td>{{ r.unscheduledWorkDays ?? 0 }}</td>
                                            </tr>
                                           
                                        </tbody>
                                    </template>
                                </v-table>
                            </v-col>
                        </v-row>

                        </div>
                    </div>
                    <div v-else>
                        <div class="card text-center my-4">
                            <div class="card-body">
                                <p class="text-muted mb-0">No matching employees found.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="card text-center">
                        <div class="card-body">
                            <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset=""
                                class="responsive-img">
                            <p>No Employee Have Been Selected.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center text-center mt-5" v-else>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <edit-employee-modal ref="editEmployee" @editedUser="onSearchClick"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="onSearchClick"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="onSearchClick"></assign-employee-modal>
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>

    <!-- Date Input Modal for Daily/Members On Site Reports -->
    <div class="modal fade" id="select_report_date_modal" ref="reportDateModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content text-start">
                <div class="modal-header">
                    <h5 class="modal-title text-black font-weight-bold">{{ reportModalTitle }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="input-block mb-3 position-relative">
                        <label class="mb-2 text-black" style="font-size: 13px; font-weight: 500;">Select Report Date</label>
                        <div class="cal-icon" style="z-index: 1060;">
                            <date-picker v-model="selectedReportDate" placeholder="Select Date"
                                class="form-control floating datetimepicker" :editable="true" :clearable="false"
                                :inputFormat="dateFormat" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-success btn-sm d-inline-flex align-items-center justify-content-center" @click="confirmDateDownload" :disabled="load || dailyReportLoad || membersOnSiteLoad">
                        <span v-if="!load && !dailyReportLoad && !membersOnSiteLoad">Download</span>
                        <span class="spinner-border spinner-border-sm" role="status" v-else>
                            <span class="visually-hidden">Loading...</span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import axios from 'axios';
import { dateRangeStart, dateRangeEnd } from '@/utils/util-var';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatDDMMYYYY, formatMMNameYYYY, minToTimeString, getImage, formatDateForApi } from '@/utils/util-funcitons';
import { shallowRef } from 'vue';
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import EditEmployeeModal from "@/components/modal/edit-employee-modal.vue";
import AddFaceTemplateModal from "@/components/modal/add-face-template-modal.vue";
import SickLeaveModal from "@/components/modal/sick-leave-modal.vue";
import LeavesAdminModal from "@/components/modal/leaves-admin-modal.vue";
import SickLeaveDetailsModal from "@/components/modal/sick-leave-details-modal.vue";
import EmployeeReportModal from "@/components/modal/employee-report-modal.vue";
import { monitorMixin } from "@/mixins/monitorMixin";

export default {
    mixins: [monitorMixin],
    components: {
        ActionDropdown,
        FaceTemplatesModal,
        EditEmployeeModal,
        AddFaceTemplateModal,
        SickLeaveModal,
        LeavesAdminModal,
        SickLeaveDetailsModal,
        EmployeeReportModal,
        AssignEmployeeModal
    },

    data() {
        return {
            startDate: new Date(dateRangeStart),
            endDate: dateRangeEnd,
            dateFormat: 'dd/MM/yyyy',
            userName: '',
            allowedBreak: '00:00',
            totalExpectedTimeOnSite: '00:00',
            totalTimeOnSiteAfterBreakDeduction: '00:00',
            totalTimeOnSiteAfterBreakSchedule: '00:00',
            totalTimeOnSiteIncludingBreakSchedule: '00:00',
            timeOnSite: '00:00',
            totalBreakTime: '00:00',
            paidLeaves: 0,
            unPaidLeaves: 0,
            workingDays: 0,
            nonWorkingDays: 0,
            presentDays: 0,
            absent: 0,
            bankedTime: '00:00',
            report: [],
            selectedUsersFromFilter: [],
            loading: false,
            load: false,
            isRefreshing: false,
            singleDownloadLoad: false,
            fullDownloadLoad: false,
            dailyReportLoad: false,
            membersOnSiteLoad: false,
            searchQuery: '',
            searchFocused: false,
            reportTypeForModal: '',
            selectedReportDate: new Date(),
            reportModalTitle: 'Select Report Date'
        }
    },
    computed: {
        filteredReport() {
            if (!this.searchQuery) {
                return this.report;
            }
            const query = this.searchQuery.toLowerCase().trim();
            return this.report.filter(r => r.userName && r.userName.toLowerCase().includes(query));
        },
        displayEndDate() {
            const value = this.endDate;
            if (!value) return ""
    
            const date = new Date(value)
    
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const year = date.getFullYear()
            return `${day}-${month}-${year}`
        },
        displayStartDate() {
            const value = this.startDate;
            if (!value) return ""
    
            const date = new Date(value)
    
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const year = date.getFullYear()
            return `${day}-${month}-${year}`
        },
    },
    methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

        capitalizeWords(str) {
            return str.replace(/\b\w/g, char => char.toUpperCase());
        },
        getImage,
        getSelectedUsers(value) {
            this.selectedUsersFromFilter = value;

            this.onSearchClick()
        },

        downloadUserReport(data) {
            this.singleDownloadLoad = true;
            const contractorDetails = {
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${data.userId}/report/download`, contractorDetails, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${data.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.singleDownloadLoad = false;
                });
        },

         downloadFullReport(data) {
            this.fullDownloadLoad = true;
            const contractorDetails = {
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${data.userId}/full-report/download`, contractorDetails, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${data.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.fullDownloadLoad = false;
                });
        },

        downloadMultiUserReport() {
            if (!this.selectedUsersFromFilter.length) {
                this.$toast.error('Select Users To get Report');
                return;
            }
            this.load = true;
           
            const contractorDetails = {
                user_ids: this.selectedUsersFromFilter,
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/user/multi-report/download`, contractorDetails, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'multi_employee_report.pdf');
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.load = false;
                });
        },

        downloadDailyAttendanceReport(date) {
            this.dailyReportLoad = true;
            const targetDate = date || this.startDate;
            const payload = {
                date: formatDateForApi(targetDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/report/daily-report/download`, payload, {
                responseType: 'blob'
            }).then(response => {
                const dateStr = formatDateForApi(targetDate);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `daily_report_${dateStr}.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.$toast.error('Download failed');
                console.error('Download failed:', error);
            })
            .finally(() => {
                this.dailyReportLoad = false;
            });
        },

        downloadMembersOnSiteList(date) {
            this.membersOnSiteLoad = true;
            const targetDate = date || this.startDate;
            const payload = {
                date: formatDateForApi(targetDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/report/members-on-site/download`, payload, {
                responseType: 'blob'
            }).then(response => {
                const dateStr = formatDateForApi(targetDate);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `members_on_site_${dateStr}.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.$toast.error('Download failed');
                console.error('Download failed:', error);
            })
            .finally(() => {
                this.membersOnSiteLoad = false;
            });
        },

        openDateModal(type) {
            this.reportTypeForModal = type;
            this.selectedReportDate = new Date(this.startDate);
            this.reportModalTitle = type === 'daily' ? 'Daily Attendance Report' : 'Members On Site List';
            
            const modal = new Modal(document.getElementById('select_report_date_modal'));
            modal.show();
        },

        confirmDateDownload() {
            const modalEl = document.getElementById('select_report_date_modal');
            const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
            modal.hide();

            if (this.reportTypeForModal === 'daily') {
                this.downloadDailyAttendanceReport(this.selectedReportDate);
            } else if (this.reportTypeForModal === 'members') {
                this.downloadMembersOnSiteList(this.selectedReportDate);
            }
        },

        toTimeString(minutes) {
            return minToTimeString(minutes);
        },
        dateToMonthName(date) {
            return formatMMNameYYYY(date);
        },
        onSearchClick() {
            if (!this.selectedUsersFromFilter.length) {
                this.$toast.error('Select Users To get Report');
            } else {
                this.getUserReport();
            }

        },
        getUserReport(event) {
            const target = event?.currentTarget;
            if (target) {
                this.isRefreshing = true;
            } else if (this.report && this.report.length > 0) {
                this.isRefreshing = true;
            } else {
                this.loading = true;
            }
            const params = {
                user_ids: this.selectedUsersFromFilter ?? [],
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            }
            axios.get(`${VUE_APP_API_BASE_URL}/report/multi-report`, { params: params })
                .then((response) => {
                    if (response.data.status && response.data.data) {
                        this.report = response.data.data
                        if (target) {
                            this.$nextTick(() => {
                                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            });
                        }
                    } else {
                        const errMsg = response.data?.message ?? (response.data?.data?.message ?? response.data?.errors ?? 'Failed to get report');
                        this.$toast.error(errMsg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.isRefreshing = false;
                });
        },
        editClicked(record) {
            this.$refs.editEmployee.updateValues(record);
        },
        sickLeaveClicked(record) {
            this.$refs.sickLeave.updateValues(record);
        },
        leavesClicked(record) {
            const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
            // Since action-dropdown now handles it, this might not be called, but we leave it for safety
            window.open(routeData.href, '_blank');
        },
        attendanceClicked(record) {
            const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
            window.open(routeData.href, '_blank');
        },
        addFaceTemplateClicked(record) {
            this.$refs.addface.updateValues(record);
        },
        faceTemplatesClicked(employee) {
            this.$refs.faceTemplates.showTemplates(employee);
        },
        viewReport(record) {
            this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
            const modal = new Modal(document.getElementById('employee_report_modal'));
            modal.show();
        },
        assignEmployeeClicked(record) {
            this.$refs.assignEmployeeModal.updateValues(record);
        },
        toggleSearch() {
            if (this.searchFocused || this.searchQuery !== '') {
                this.$refs.searchInput.focus();
            } else {
                this.searchFocused = true;
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            }
        },
        clearSearch() {
            this.searchQuery = '';
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        },
    },
    mounted() {
        // this.getUserReport();
    }
}
</script>

<style scoped>
.floating-search-container {
    position: fixed;
    top: 95px;
    right: 30px;
    z-index: 1050;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
}

.floating-search-container.expanded {
    width: 250px;
    border-radius: 6px;
}

.floating-search-container:hover {
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
}

.search-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.search-input-field {
    width: 100%;
    height: 100%;
    border: none !important;
    outline: none !important;
    padding: 8px 40px 8px 12px !important;
    background: transparent;
    font-size: 14px;
    color: #333333;
}

.search-icon-btn {
    width: 38px;
    height: 38px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}

.floating-search-container.expanded .search-icon-btn {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    height: auto;
}

.search-icon-btn i {
    font-size: 16px;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important;
}

.search-icon-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.filter-row {
    justify-content: flex-end;
}

.employee-name {
    margin-right: auto;
    display: flex;
    align-items: center;
}

.report:last-child hr {
    --v-border-opacity: 0 !important;
}

.responsive-img {
    width: 100%;
    max-width: 100px;
    height: auto;
}

.h3 {
    font-weight: 500 !important;
}

tbody, thead {
    font-size: 16px;
}
</style>